import { createFileRoute } from "@tanstack/react-router";
import ContratoDetalhe from "@/pages/admin/ContratoDetalhe";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/admin/contratos/$id/")({
  head: () => pageHead({ title: "Contrato | Painel", path: "/admin/contratos", noindex: true }),
  component: ContratoDetalhe,
});
